import { render } from "./Pack.vue?vue&type=template&id=61c648e3"
import script from "./Pack.vue?vue&type=script&lang=js"
export * from "./Pack.vue?vue&type=script&lang=js"

import "./Pack.vue?vue&type=style&index=0&id=61c648e3&lang=scss"

import exportComponent from "G:\\司机仓库\\warehouseModule\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__